<div class="row">
  <div class="col-md-3 bg-white rounded shadow">
    <div class="pl-3 pr-5">
      <app-navbar [step]="8">
      </app-navbar>
    </div>
  </div>
  <div class="col-md-9">
<app-breadcrumb [title]="'Create New Grievance'"></app-breadcrumb>
<section class="container">
  <div class="card border-0 bg-white rounded-3 shadow mb-5">
    <div class="card-body">
      <form class="px-lg-4 py-0" [formGroup]="grievanceFrom" (ngSubmit)="submit()" novalidate>
        <div class="pe-2 px-2">
          <div class="form-group mb-3">
            <label class="form-label fw-bold" for="grievanceTypeId">
              Query Type
              <small class="text-danger">*</small>
            </label>
            <select MyInput formControlName="grievanceTypeId" class="form-select ">
              <option value="" selected>--SELECT--</option>
              <option *ngFor="let item of returTypes" value="{{ item.value }}">{{ item.text }}
              </option>
            </select>
            <my-error controlName="grievanceTypeId" errorKey="required">Query Type is required</my-error>
          </div>
          <div class="form-group mb-3">
            <label class="mb-0" for="comment">
              <b>
                Inquiry/Comments
                <small class="text-danger">*</small>
              </b>
            </label>
            <div class="row pe-2 px-2 mt-2">
              <textarea rows="4" MyInput formControlName="comment" id="comment" class="form-control "></textarea>
              <my-error controlName="comment" errorKey="required">Inquiry/Comments is required
              </my-error>
            </div>
          </div>
          <div>
            <div class="px-lg-0">
              <div class="form-group mb-3">
                <label class="form-label fw-bold" for="proficiencyId">
                  Upload Document
                </label>
                <input type="file" class="form-control" #inputUniqueDoc
                  (change)="handleFileInput($event.target.files);onDocumentUpload(inputUniqueDoc)">
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="row">
        <div class="col-lg-12">
          <div class="form-group mb-3 d-flex justify-content-end">
            <button (click)="submit()" class="btn btn-primary rounded-3 border-2 m-3 px-5"
              [disabled]="!grievanceFrom.valid || loading" type="submit">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="loading"></span>
              Submit</button>
            <button (click)="cancelClick()" class="btn btn-outline-dark rounded-3 border-2 m-3 px-5"
              type="reset">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
</div>
</div>
